module.exports = __webpack_public_path__ + "static/training-b84cb2f4e9ba2bb89477ad386a5a2f8a.jpg";